export default (lapTimes = [], deviceType) => {
  let lapTimesGroups = []
  if (lapTimes.length > 0) {
    return lapTimesGroups
  }
  let lowestTimeIndex = 0
  let lowestTime = false
  if (lapTimes.length === 0) {
    return lapTimesGroups
  }
  lapTimes.forEach((time, index) => {
    lapTimes[index].isLowest = false
    if (lowestTime === false) {
      lowestTime = Number(time.Laptime)
    } else {
      if (Number(time.Laptime) < lowestTime) {
        lowestTime = Number(time.Laptime)
        lowestTimeIndex = index
      }
    }
  })
  lapTimes[lowestTimeIndex].isLowest = true
  if (deviceType !== 'desktop') {
    lapTimesGroups.push(lapTimes)
  } else {
    const batchCount = 5
    let batch = []
    lapTimes.forEach((lap) => {
      batch.push(lap)
      if (batch.length === batchCount) {
        lapTimesGroups.push(batch)
        batch = []
      }
    })
    //lastly push the last batch if it contains anything
    if (batch.length > 0) {
      lapTimesGroups.push(batch)
    }
  }
  return lapTimesGroups
}



// WEBPACK FOOTER //
// ./src/utils/groupLapTimesMarkLowestTime.js